// SessionForm.js
import React from 'react';
import TextArea from './TextArea';
import editIcon from '../images/edit-line.svg';
import quoteIcon from '../images/chat-line.svg';
import StarRating from './StarRating';

const SessionForm = ({
  quote,
  summary,
  rating,
  review,
  handleQuoteChange,
  handleSummaryChange,
  handleReviewChange,
  setRating,
  showReview,
  t,
}) => (
  <form className="form">
    <h2 className="fs-l form-header">{t.addpersonalMessage}</h2>

    <TextArea
      type="textarea"
      icon={quoteIcon}
      labelName={t.quoteLabel}
      id="quote"
      value={quote}
      onChangeFunction={handleQuoteChange}
    />

    <TextArea
      type="textarea"
      icon={editIcon}
      labelName={t.summaryLabel}
      id="summary"
      value={summary}
      onChangeFunction={handleSummaryChange}
    />

    {showReview && <StarRating rating={rating} setRating={setRating} />}
    {showReview && (
      <TextArea
        type="textarea"
        icon={editIcon}
        labelName={t.reviewLabel}
        id="review"
        value={review}
        onChangeFunction={handleReviewChange}
      />
    )}
  </form>
);

export default SessionForm;
